const config = {
  generate_otp: "/auth/otp",
  verify_otp: "/auth/otp/verification",
  login: "/auth/token",
  user: "/users",
  props: "/properties",
  fav: "favorites",
  reviews: "reviews",
  bookings: "bookings/guest",
  ownerProfile: "/users",
} as const;

export default config;
